module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('nav-bar', {
    on: {
      "click-menu": function () { return _vm.showTab = true; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in-down"
    }
  }, [_c('mobile-search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab),
      expression: "showTab"
    }],
    on: {
      "close": function () { return _vm.showTab = false; }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445cf55e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/home.vue
// module id = 679
// module chunks = 57